export enum TealiumToolState {
	STARTED = 'started',
	COMPLETED = 'completed',
	PORTFOLIO_EDITOR = 'portfolio editor'
}
